import './LiveboardLayout.style.less'

import { Route, Routes } from 'react-router-dom'

// import KPIBoard from '../KPIBoard/KPIBoard'
import PBFBoard from '../PBFBoard/PBFBoard'
import ProductsBoard from '../ProductsBoard/ProductsBoard'
import QSFBoard from '../QSFBoard/QSFBoard'
// import QMSBoard from '../QMSBoard'

function LiveboardLayout() {
  return (
    <Routes>
      <Route path="QSF" element={<QSFBoard />} />
      <Route path="PBF" element={<PBFBoard />} />
      <Route path="PRODUCTS" element={<ProductsBoard />} />
      {/* <Route path="KPI" element={<KPIBoard />} />
        <Route path="QMS" element={<QMSBoard />} /> */}
    </Routes>
  )
}

export default LiveboardLayout
